import { config } from 'config';

const {
  baseUrl,
  sessionAssistBaseUrl,
  sessionAssistBaseWs,
  sessionApiBaseUrl,
} = config;

export const apiUrls = {
  projects: `${baseUrl}/projects`,
  projectGroups: `${baseUrl}/project-groups`,
  songs: `${sessionApiBaseUrl}/songs`,
  shares: `${sessionApiBaseUrl}/shares`,
  songsFolders: `${sessionApiBaseUrl}/songs/folders`,
  songsPins: `${sessionApiBaseUrl}/songs/pins`,
  profiles: `${sessionApiBaseUrl}/profiles`,
  settings: `${sessionAssistBaseUrl}/api/settings`,
  settingsChanges: `${sessionAssistBaseWs}/api/settings/changes`,
  apiKeyWeb: `${sessionApiBaseUrl}/settings/public?scopes=org-session:api-key-web`,
  bootstrap: `${sessionApiBaseUrl}/bootstrap/org-session`,
  services: {
    shares: `${sessionApiBaseUrl}/shares/discover?authenticated=false`,
  },
  importCSV: {
    post: `${sessionApiBaseUrl}/songs/import`,
    get: `${sessionApiBaseUrl}/songs/import/current`,
  },
  uploadAudio: `${sessionApiBaseUrl}/songs/:songGuid/audio`,
  createLyrics: `${sessionApiBaseUrl}/lyrics-2/:songGuid`,
  syncRelease: `${sessionApiBaseUrl}/releases-2/:releaseGuid/versions/:versionGuid/sync`,
};

export const externalLinks = {
  mobileApp: {
    IOS_APP_LINK: 'https://apps.apple.com/app/session-studio/id1570114999',
    ANDROID_APP_LINK:
      'https://play.google.com/store/apps/details?id=id.session.studio.mobile',
  },
  signUp: {
    TERMS_AND_CONDITIONS: 'https://www.sessionstudio.com/terms-of-use',
    PRIVACY_POLICY: 'https://www.sessionstudio.com/privacy-policy',
  },
  subscriptions: {
    TERMS_AND_CONDITIONS: 'https://www.sessionstudio.com/terms-of-use',
  },
  sessionLanding: 'https://www.sessionstudio.com',
};
